export const DOCUMENT_STATUS_OPTIONS = [
  { value: "uploaded", label: "Cargado" },
  { value: "processing", label: "Procesando" },
  { value: "pending_review", label: "Pendiente de revisión" },
  { value: "assigned", label: "Asignado" },
  { value: "error", label: "Error" },
] as const;

export const INVOICE_STATUS_OPTIONS = [
  { value: "uploaded", label: "Cargado" },
  { value: "processing", label: "Procesando" },
  { value: "pending_review", label: "Pendiente de revisión" },
  { value: "reviewed", label: "Revisada" },
  { value: "assigned", label: "Asignada" },
  { value: "error", label: "Error" },
] as const;
